exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hitArea {\n  background-color: rgba(255, 0, 0, 0);\n  position: absolute;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/css/ui/hitArea.css
// module id = 22
// module chunks = 0